import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { cn } from '../lib/utils';
type Props = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  size?: 'md' | 'lg';
  variant?: 'rojo' | 'plata';
};
export const CHECKOUT_URL = 'https://codigo-infidelidad-el-manual-de-los-7-dias.impultienda.ar/checkout';
export function CTAButton({
  children,
  className = '',
  href = CHECKOUT_URL,
  size = 'lg',
  variant = 'rojo'
}: Props) {
  const pad = size === 'lg' ? 'min-h-[65px] px-8 py-4 text-[18px]' : 'min-h-[58px] px-6 py-3.5 text-base';
  const skin = variant === 'plata' ? 'bg-plata text-ink shadow-[0_10px_40px_-8px_rgba(201,206,214,0.45)] ring-1 ring-plata-soft/70 hover:bg-plata-soft hover:shadow-[0_16px_50px_-8px_rgba(201,206,214,0.65)] focus-visible:ring-rojo' : 'bg-rojo text-white shadow-[0_10px_40px_-8px_rgba(214,31,43,0.8)] ring-1 ring-plata/40 hover:bg-rojo-deep hover:shadow-[0_16px_50px_-8px_rgba(214,31,43,0.95)] focus-visible:ring-plata';
  return <a href={href} className={cn('group inline-flex w-full max-w-[320px] items-center justify-center gap-2 rounded-xl text-center font-extrabold uppercase leading-tight tracking-wide transition-all duration-200 hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2', skin, pad, className)} data-id="element-51" data-mp="19ahd8tgfwqzt">
      {children}
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 group-hover:translate-x-1" data-id="element-52" data-mp="1s8k4zg0dh21b" />
    </a>;
}